const themeFonts = {
  fontPrimary: "Open Sans",
  fontSecondary: "Lato",
  fontAwesome: "FontAwesome",
  baseLineHeight: "1.5",
}

export default themeFonts
